document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]')
  if (!select) return
  const option = select.options[select.selectedIndex]
  const price = option.dataset.price
  const available = option.dataset.available === 'true'
  const priceEl = document.querySelector('[data-product-price]')
  const button = document.querySelector('[data-add-to-cart]')
  if (priceEl && price) priceEl.textContent = price
  if (button) { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out' }
})
